import { Box, Text, Image, Flex } from "@chakra-ui/react"
import { PublicationBlockBrissagoPublic } from "../../client"

const BrissagoBlock = ({ data }: { data: PublicationBlockBrissagoPublic }) => {
    return (
        <Flex my={10} boxShadow={"rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"} borderRadius="md" justifyContent="center">
            <Box>
                <Image src={data?.fk_media?.path} alt={data?.fk_media?.file_name} borderTopRadius="md" />
                {data.description &&
                    <Text py={4} pl={4}>{data.description}</Text>
                }
            </Box>
        </Flex>
    )
}

export default BrissagoBlock